const Right = () => {
    return ( 
        <div className="scrolldown">
            <a href="#contact">scroll down</a>
        </div>
     );
}
 
export default Right;